/**
 * Environment-specific configuration.
 * Exports configuration values based on the current NODE_ENV.
 */

const environment = process.env.NODE_ENV || 'development';

const config = {
  development: {
    environment: 'development',
    isDevelopment: true,
    isProduction: false,
    isTest: false,
    enableLogging: true,
    apiTimeout: 30000,
  },
  production: {
    environment: 'production',
    isDevelopment: false,
    isProduction: true,
    isTest: false,
    enableLogging: false,
    apiTimeout: 15000,
  },
  test: {
    environment: 'test',
    isDevelopment: false,
    isProduction: false,
    isTest: true,
    enableLogging: false,
    apiTimeout: 5000,
  },
};

/**
 * Demo account credentials.
 * The actual demo account must be manually created in Firebase Console
 * before these environment variables will work.
 *
 * Required env vars:
 *   REACT_APP_DEMO_USER_EMAIL - email for the pre-created demo Firebase account
 *   REACT_APP_DEMO_USER_PASSWORD - password for the demo account
 */
export const demoConfig = {
  email: process.env.REACT_APP_DEMO_USER_EMAIL || '',
  password: process.env.REACT_APP_DEMO_USER_PASSWORD || '',
};

export default config[environment] || config.development;
